import { Box, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const AllPaidOffBox = () => {
  return (
    <Box
      sx={{
        borderRadius: "16px",
        border: "1px solid #d1d9ff",
        padding: "32px 24px",
        backgroundColor: "#f5f6fe",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: "24px",
        boxShadow: "0 4px 12px rgba(85, 84, 243, 0.1)",
      }}
    >
      <CheckCircleOutlineIcon sx={{ fontSize: 44, color: "#5664F5" }} />
      <Typography
        variant="h6"
        sx={{
          fontWeight: 700,
          marginTop: "8px",
          fontSize: "1.2rem",
          color: "#333",
          textAlign: "center",
          fontFamily: "Montserrat",
        }}
      >
        Все задолженности погашены
      </Typography>
      <Typography
        sx={{
          marginTop: "3px",
          color: "#666",
          fontSize: "0.95rem",
          textAlign: "center",
          fontFamily: "Montserrat",
        }}
      >
        По данному лицевому счету у вас нет активных долгов.
      </Typography>
    </Box>
  );
};

export default AllPaidOffBox;
